module.exports = __webpack_public_path__ + "img/Enovos_80X30.e0fbd196.png";